import stateMapper from './state-mapper'

export {
  stateMapper
}
